import { useI18n } from 'vue-i18n';

const getValidationMessages = () => {
  const { t } = useI18n();

  return {
    required: t('passwordValidator.passwordRequired'),
    minLength: t('passwordValidator.minLength'),
    maxLength: t('passwordValidator.maxLength'),
    lowercase: t('passwordValidator.lowercase'),
    uppercase: t('passwordValidator.uppercase'),
    containNumber: t('passwordValidator.containNumber'),
    specialCharacter: t('passwordValidator.specialCharacter'),
  };
};

export default getValidationMessages;
